import { useCallback, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import TextField from "@mui/material/TextField";

import Api from "../../../../services/Api";
import useAuth from "../../../login/AuthContext";

export const TagAddModal = ({ state, setData, onSuccess }) => {
  const [value, setValue] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const { getAuthToken } = useAuth();
  const onClose = useCallback(() => {
    setData(null);
    setLoading(false);
  }, []);
  const onChange = useCallback((event) => {
    setValue(event.target.value);
  }, []);
  const onAdd = useCallback(async () => {
    setLoading(true);
    const response = await Api.addTag(value, await getAuthToken());

    if (response.status === 200) {
      onSuccess(response.parsedBody);
    } else {
      setError(response.parsedBody?.error?.description || true);
    }

    setLoading(false);
  }, [getAuthToken, value]);

  useEffect(() => {
    if (state) {
      setError(false);
      setValue("");
    }
  }, [state]);

  return (
    <Modal show={state} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add Tag</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {error ? (
          <Alert variant="danger">
            {typeof error === "string" ? "Error - " + error : "An error occurred while adding tag"}
          </Alert>
        ) : null}

        <TextField variant="outlined" value={value} placeholder="Tag Name" onChange={onChange} />
      </Modal.Body>

      <Modal.Footer>
        {loading ? <Spinner variant="primary" size="sm" animation="border" /> : null}
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button isLoading={loading} variant="primary" onClick={onAdd} disabled={!value || loading}>
          Add Tag
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
